export class Rectangle {
  constructor(public x: number, public y: number, public width: number, public height: number) {
  }
}
